/**
 * The "Why Metal Matters" teaser on the Ryerson Commitment landing page
 * (`src/pages/why-ryerson/ryerson-commitment/index.tsx`, its only importer), linking to
 * `/why-ryerson/ryerson-commitment/why-metal-matters/`. The folder and symbol names say
 * Sustainability; the copy in `./Content.tsx` is Why Metal Matters. It has no layout of its own:
 * it renders the Product Quality teaser layouts (`../ProductQuality/ProductQualityDesktop.tsx`,
 * `ProductQualityMobile.tsx`).
 */
import { Media } from "@ryerson/frontend.next";
import React from "react";
import { SustainabilityContent } from "./Content";
import ProductQualityDesktop from "../ProductQuality/ProductQualityDesktop";
import ProductQualityMobile from "../ProductQuality/ProductQualityMobile";
import { useApplication } from "@ryerson/frontend.application";

/** `ContentSection` background type; a copy of `../ProductQuality/ProductQuality.tsx`'s. */
export type backgroundType = "primary" | "secondary";

/**
 * Same shape as `../ProductQuality/ProductQuality.tsx` → `ProductQualityProps`, which documents
 * the fields; the content is spread straight into those layouts.
 */
export interface SustainabilityProps {
	background?: backgroundType;
	imageUrl: string;
	title: string;
	content: string;
	buttonLabel: string;
	moreAboutLink: string;
}

/** Renders the Why Metal Matters teaser in the visitor's language, mobile below `lg`. */
const Sustainability: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	return (
		<>
			<Media lessThan="lg">
				<ProductQualityMobile {...SustainabilityContent[language]} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<ProductQualityDesktop {...SustainabilityContent[language]} />
			</Media>
		</>
	);
};

export default Sustainability;
